( function ( window, document ) {
	'use strict';

	function init( root ) {
		const scope = root && root.querySelectorAll ? root : document;
		const toggles = scope.querySelectorAll(
			'.bakery-card__meta__container-action-expand'
		);

		if ( ! toggles.length ) {
			return;
		}

		toggles.forEach( function ( toggle ) {
			if ( toggle.dataset.bakeryCardBound === '1' ) {
				return;
			}

			toggle.dataset.bakeryCardBound = '1';
			toggle.addEventListener( 'click', function () {
				const card = toggle.closest( '.bakery-card' );

				if ( ! card ) {
					return;
				}

				card.classList.toggle( 'active' );
			} );
		} );
	}

	window.SweettySpaceBakeryCard = window.SweettySpaceBakeryCard || {
		init,
	};

	if ( document.readyState === 'loading' ) {
		document.addEventListener(
			'DOMContentLoaded',
			function () {
				init();
			},
			{ once: true }
		);
	} else {
		init();
	}
} )( window, document );
